import {Routes} from '@angular/router';

import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';

export const AppRoutes: Routes = [
  // {
  //   path: '',
    
  //   children: [
  //     {
        
  //       path: '',
  //       redirectTo: 'start',
  //       pathMatch: 'full'
  //     }
  //     ,
  //      {
  //       path: 'start',
  //       loadChildren: './authentication/prelogin/prelogin.module#PreloginModule'
  //     }
  //     , {
  //       path: 'login',
  //       loadChildren: './authentication/login/login.module#LoginModule'
  //     }

  //     , {
  //       path: 'branch',
  //       loadChildren: './authentication/branchwise/branchwise.module#BranchModule'
  //     }

  //     , {
  //       path: 'staff',
  //       loadChildren: './authentication/staffwise/staffwise.module#StaffModule'
  //     }
  //     , {
  //       path: 'doc',
  //       loadChildren: './authentication/doctor/doctor.module#DoctorModule'
  //     }
  //   ]
  // },
  {
  path: '',
  component: AdminLayoutComponent,
  children: [
    {
        
      path: '',
      redirectTo: 'Payments',
      pathMatch: 'full'
    },
    
    {
      path: 'applicationform/:clcd',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './Payments/Payments.module#PaymentsModule'
    },
    {
      path: 'applicationpage/:clcd',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './PgReg/PgReg.module#PgRegModule'
    },
    {
      path: 'paymentresult/:retmsg',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './Exprzpayresp/Exprzpayresp.module#ExprzpayrespModule'
    },
    {
      path: 'applicationresp/:retmsg',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './Exprzpayresp/Exprzpayresp.module#ExprzpayrespModule'
    },
    {
      path: 'registercomplete',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './Exprzpay/Exprzpay.module#ExprzpayModule'
    },
    {
      path: 'admissionenquiry',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './Regformsims/Regformsims.module#RegsimsModule'
    },
    {
      path: 'Docupload/:cldb/:enid/:orderid',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './docpage/Docpage.module#DocpagepModule'
    },
    {
      // path: 'memberreg',
      path: 'Register',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './memberform/memberform.module#MemberFormModule'
    },

    {
      // path: 'memberreg',
      path: 'Stureg',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './stureg/stureg.module#SturegModule'
    },
    {
      // path: 'memberreg',
      path: 'Stfreg',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './stfreg/stfreg.module#StfregModule'
    },
    {
      // path: 'memberreg',
      path: 'sturegid',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './sturegid/sturegid.module#SturegidModule'
    },
    
    {
      // path: 'memberreg',
      path: 'sturegdg',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './sturegdg/sturegdg.module#SturegdgModule'
    },
    {
      path: 'login/:clcd/:aycd',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './feedbacklogin/feedbacklogin.module#FeedbackloginModule'
    },

    {
      path: 'stulogin/:clcd/:tag',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './stulogin/stulogin.module#StuloginModule'
    },

    {
      path: 'stflogin/:clcd/:tag',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './stflogin/stflogin.module#StfloginModule'
    },

    {
      path: 'Register1',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './memberregisterform/memberform.module#MemberregFormModule'
    },

    {
      path: 'Admissionenquiry/:clcd',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './Enquiry/Enquiry.module#EnquiryModule'
    },
    {
      path: 'enquiryeng/:clcd',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './Stuenquiry/Stuenquiry.module#StuenquiryModule'
    },
    {
      path: 'enquirypg/:clcd',
      // loadChildren: './dashboard/dashboard.module#DashboardModule'
      loadChildren: './stuenquirypg/Stuenquirypg.module#StuenquirypgModule'
    },
  ]
}, 
 {
  path: '**',
  redirectTo: 'error/404'
}];



// WEBPACK FOOTER //
// D:/Angular projects/memberreg/memberreg/src/app/app.routing.ts